import React from 'react'

export default function ResetPass() {
  return (
    <div>ResetPass</div>
  )
}
